/**
* @license lucide-solid v0.363.0 - ISC
*
* This source code is licensed under the ISC license.
* See the LICENSE file in the root directory of this source tree.
*/

// src/icons/badge-check.tsx
import Icon from "../Icon";
var iconNode = [
  [
    "path",
    {
      d: "M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z",
      key: "3c2336"
    }
  ],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
];
var BadgeCheck = (props) => <Icon {...props} name="BadgeCheck" iconNode={iconNode} />;
var badge_check_default = BadgeCheck;
export {
  badge_check_default as default
};
//# sourceMappingURL=badge-check.jsx.map
